import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static get values() {
        return {
            active: Boolean,
            position: Number,
            id: String,
        }
    }

    open() {
        window.dispatchEvent(new CustomEvent('openTab', {
            detail: {
              position: this.positionValue,
              id: this.idValue,
            },
        }));
    }

    update(event) {
        const position = event.detail.position;
        const id = event.detail.id;

        if (id !== this.idValue) {
            return null;
        }

        if (position == this.positionValue) {
            this.activeValue = true;
        } else {
            this.activeValue = false;
        }
    }
}
